<!-- Dialog Selector Header -->
<div class="row" style="height: 120px">

	<ul class="listPicker" style="margin-left: 16px; margin-right: 16px;">
		<li [class.checked]="mOriginalDialog != null">
			USE EXISTING DIALOG
			<span style="padding-left: 140px;">
				<span class="dropdown">
					<button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
						<i class="fa fa-comments-o ents"></i>
						{{mOriginalDialog == null? ' SELECT DIALOG ' : mOriginalDialog.name}}
						<span class="caret"></span>
					</button>
					<ul class="dropdown-menu" style="height: 250px; overflow-y: auto;">
						<li *ngFor="let dialog of mDialogs" (click)="selectDialogToEdit(dialog)">
							<a>
								{{dialog.name}}
							</a>
						</li>
					</ul>
				</span>
			</span>
		</li>

		<li class="ListPickerItem" [class.checked]="mOriginalDialog == null" (click)="selectDialogToEdit(null)">
			CREATE A CUSTOM DIALOG
		</li>
	</ul>

</div>


<!-- Dialog Editor Pane -->
<div class="row">

	<div class="col-sm-3">

		<div class="panel-group" id="dialogEditorAccordion_{{mUniqueIndex}}" >

			<div class="panel panel-default">
				<div class="panel-heading">
					<h4 class="panel-title">
						<a data-toggle="collapse" href="#dialogEditorAccordionRecipients_{{mUniqueIndex}}">
							<i class="fa fa-users" aria-hidden="true"></i>
							RECIPIENTS
						</a>
					</h4>
				</div>

				<div class="panel-collapse collapse" id="dialogEditorAccordionRecipients_{{mUniqueIndex}}">
					<app-dialog-recipients
						[mAction]="mAction"
						[dialog]="mEditDialog"
						>
					</app-dialog-recipients>
				</div>
			</div>

			<div class="panel panel-default">
				<div class="panel-heading">
					<h4 class="panel-title">
						<a data-toggle="collapse" href="#dialogEditorAccordionMessage_{{mUniqueIndex}}">
							<i class="fa fa-pencil" aria-hidden="true"></i>
							MESSAGE
						</a>
					</h4>
				</div>

				<div class="panel-collapse collapse" id="dialogEditorAccordionMessage_{{mUniqueIndex}}">
					<div class="checkbox checkbox-inline">
						<input [checked]="mEditDialog.message != null" (change)="showMessageChanged($event.target.checked)" type="checkbox" class="styled" />
						<label>SHOW MESSAGE FIELD?</label>
					</div>
					<p>A message filed is good if you want an explanation or summary of what happened.</p>
				</div>
			</div>

			<div class="panel panel-default">
				<div class="panel-heading">
					<h4 class="panel-title">
						<a data-toggle="collapse" href="#dialogEditorAccordionChecklist_{{mUniqueIndex}}">
							<i class="fa fa-check" aria-hidden="true"></i>
							CHECKLIST
						</a>
					</h4>
				</div>

				<div class="panel-collapse collapse" id="dialogEditorAccordionChecklist_{{mUniqueIndex}}">
					<div class="panel-body">
						<div class="checkbox checkbox-inline">
							<input type="checkbox" [checked]="mEditDialog.items != null" (change)="showChecklistChanged($event.target.checked)" class="styled" />
							<label>SHOW CHECKLIST?</label>
						</div>
						<p>Checklist items are good for helping guide a user through an incident.  We recommend adding no more than 4 or 5.</p>
						<p><input type="text" [(ngModel)]="mEditDialog.itemsHeader" class="form-control" placeholder="Checklist Title" />
						<div class="input-group" style="padding-bottom: 20px; max-width: 100%">
							<input type="text" [(ngModel)]="mChecklistItemName" class="form-control" placeholder="Checklist Item..." style="color: #ffffff" />
							<div class="input-group-btn">
								<button type="button" (click)="addChecklistItemClicked()" class="btn btn-primary" tabindex="-1">
									<i class="fa fa-plus" aria-hidden="true"></i>
									ADD
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="panel panel-default">
				<div class="panel-heading">
					<h4 class="panel-title">
						<a data-toggle="collapse" href="#dialogEditorAccordionMap_{{mUniqueIndex}}">
							<i class="fa fa-map" aria-hidden="true"></i>
							MAP
						</a>
					</h4>
				</div>

				<div class="panel-collapse collapse" id="dialogEditorAccordionMap_{{mUniqueIndex}}">
					<div class="panel-body">
						<div class="checkbox checkbox-inline">
							<input [(ngModel)]="mEditDialog.showMap" type="checkbox" class="styled" />
							<label>SHOW MAP?</label>
						</div>
						<p>When an alert occurs, the map area will show the location of the incident.</p>
					</div>
				</div>
			</div>

			<div *ngIf="mEditDialog.showMap" class="panel panel-default">
				<div class="panel-heading">
					<h4 class="panel-title">
						<a data-toggle="collapse" href="#dialogEditorAccordionMapOptions_{{mUniqueIndex}}">
							<i class="fa fa-map" aria-hidden="true"></i>
							MAP OPTIONS
						</a>
					</h4>
				</div>

				<div class="panel-collapse collapse" id="dialogEditorAccordionMapOptions_{{mUniqueIndex}}">
					<div class="panel-body">
							<div class="checkbox checkbox-inline">
								<input [(ngModel)]="customMapOptions" type="checkbox" class="styled" />
								<label>CUSTOM MAP OPTIONS?</label>
							</div>
						<p>Customize the default options applied to the Map.</p>
						<ng-container *ngIf="customMapOptions">
							<div class="checkbox checkbox-inline">
								<input [(ngModel)]="mEditDialog.mapOptions.assets" type="checkbox" class="styled" />
								<label>DISPLAY ASSETS?</label>
							</div>
							<div class="checkbox checkbox-inline">
								<input [(ngModel)]="mEditDialog.mapOptions.people" type="checkbox" class="styled" />
								<label>DISPLAY PEOPLE?</label>
							</div>
							<div class="checkbox checkbox-inline">
								<input [(ngModel)]="mEditDialog.mapOptions.perimeters" type="checkbox" class="styled" />
								<label>DISPLAY PERIMETERS?</label>
							</div>
							<div class="checkbox checkbox-inline">
								<input [(ngModel)]="mEditDialog.mapOptions.breadcrumbs" type="checkbox" class="styled" />
								<label>DISPLAY BREADCRUMBS?</label>
							</div>
							<div class="checkbox checkbox-inline">
								<input [(ngModel)]="mEditDialog.mapOptions.zones" type="checkbox" class="styled" />
								<label>DISPLAY ZONES?</label>
							</div>
							<div class="checkbox checkbox-inline">
								<input [(ngModel)]="mEditDialog.mapOptions.zonenames" type="checkbox" class="styled" />
								<label>DISPLAY ZONE NAMES?</label>
							</div>
              <div class="checkbox checkbox-inline">
                <input [(ngModel)]="mEditDialog.mapOptions.sublocations" type="checkbox" class="styled" />
                <label>DISPLAY SUBLOCATIONS?</label>
              </div>
              <div class="checkbox checkbox-inline">
                <input [(ngModel)]="mEditDialog.mapOptions.sublocationnames" type="checkbox" class="styled" />
                <label>DISPLAY SUBLOCATION NAMES?</label>
              </div>
							<div class="checkbox checkbox-inline">
								<input [(ngModel)]="mEditDialog.mapOptions.zoomToZone" type="checkbox" class="styled" />
								<label>ZOOM TO ZONE?</label>
							</div>
						</ng-container>
					</div>

					<div *ngIf="customMapOptions" class="panel-body">
						<div class="form-group">
							<span class="dropdown">
									<button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">CHOOSE ASSETS / PEOPLE<span class="caret"></span></button>
									<ul class="dropdown-menu" (click)="$event.stopPropagation()">
										<div style="overflow-y: auto; max-height: 300px">
												<div class="table-responsive">
													<table class="table table-hover">
														<tbody>
															<ng-container *ngFor="let option of getObjectsOfInterestOptions()">
																<tr>
																	<td>
																		<div class="checkbox checkbox-inline" style="cursor: pointer;">
																			<input [checked]="isObjectOfInterestSelected(option)" (change)="selectObjectOfInterest(option, $event.target.checked)" type="checkbox" class="styled" />
																			<label style="cursor: pointer;"></label>
																		</div>
																	</td>
																	<td (click)="selectObjectOfInterest(option, !isObjectOfInterestSelected(option))" style="cursor: pointer;">
																		{{option.mDisplayValue}}
																	</td>
																</tr>
															</ng-container>
														</tbody>
													</table>
												</div>
											</div>
									</ul>
							</span>
						</div>
					</div>
				</div>
			</div>

			<div class="panel panel-default">
				<div class="panel-heading">
					<h4 class="panel-title">
						<a data-toggle="collapse" href="#dialogEditorAccordionComments_{{mUniqueIndex}}">
							<i class="fa fa-pencil" aria-hidden="true"></i>
							COMMENTS
						</a>
					</h4>
				</div>

				<div class="panel-collapse collapse" id="dialogEditorAccordionComments_{{mUniqueIndex}}">
					<div class="panel-body">
						<div class="checkbox checkbox-inline">
							<input [(ngModel)]="mEditDialog.showComment" type="checkbox" class="styled" />
							<label>SHOW COMMENT FIELD?</label>
						</div>
						<p>A comment field is good if you want a user to submit an explanation or summary of what happened.</p>
						<p><input [(ngModel)]="mEditDialog.messageHeader" type="text" class="form-control" placeholder="Comment Field Title" /></p>
					</div>
				</div>
			</div>

			<div class="panel panel-default">
				<div class="panel-heading">
					<h4 class="panel-title">
						<a data-toggle="collapse" href="#dialogEditorAccordionButtons_{{mUniqueIndex}}">
							<i class="fa fa-circle" aria-hidden="true"></i>
							BUTTONS
						</a>
					</h4>
				</div>

				<div class="panel-collapse collapse" id="dialogEditorAccordionButtons_{{mUniqueIndex}}">
					<app-dialog-buttons
						[dialog]="mEditDialog"
						[selectedButton]="mSelectedButton"
						(selectButton)="mSelectedButton = mSelectedButton == $event? null : $event"
						>
					</app-dialog-buttons>
				</div>
			</div>

			<div class="panel panel-default">
				<div class="panel-heading">
					<h4 class="panel-title">
						<a data-toggle="collapse" href="#dialogEditorAccordionResponseTime_{{mUniqueIndex}}">
							<i class="fa fa-clock-o" aria-hidden="true"></i>
							RESPONSE TIME
						</a>
					</h4>
				</div>

				<div class="panel-collapse collapse" id="dialogEditorAccordionResponseTime_{{mUniqueIndex}}">
					<app-dialog-response-time
						[mAction]="mAction"
						[dialog]="mEditDialog"
						>
					</app-dialog-response-time>
				</div>
			</div>

		</div>
	</div>

	<div class="col-sm-9">
		<app-dialog-display
			[dialog]="mEditDialog"
			[mUniqueIndex]="this.mUniqueIndex"
			[mEvent]="this.mEvent"
			[selectedButton]="mSelectedButton"
			(selectButton)="mSelectedButton = mSelectedButton == $event? null : $event"
			>
		</app-dialog-display>
	</div>

	<div class="col-sm-12" align="right">
		<ng-container *ngIf="isNewDialog()">
			<button (click)="createDialog()" type="button" class="btn btn-primary">
				<i class="fa fa-floppy-o"></i>
				CREATE DIALOG
			</button>
		</ng-container>
		<ng-container *ngIf="!isNewDialog()">
			<button (click)="duplicateDialog()" type="button" class="btn btn-primary" style="margin-right: 5px">
				<i class="fa fa-floppy-o"></i>
				CREATE COPY
			</button>
			<button (click)="updateDialog()" type="button" [class.disabled]="!isDialogChanged()" class="btn btn-primary">
				<i class="fa fa-floppy-o"></i>
				UPDATE DIALOG
			</button>
		</ng-container>
	</div>

	<div id="dialogMessageSnackbar_{{mUniqueIndex}}" class="col-sm-12" align="right">
		{{mSnackbarMessage}}
	</div>
</div>

<!-- Simple Success Error Dialog Box - Displaying the Error generated for now since we dont display success msgs -->
<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>